export { RTreeID };
class RTreeID {
    constructor({ id, minX, maxX, minY, maxY }) {
        this.id = id;
        this.minX = minX;
        this.maxX = maxX;
        this.minY = minY;
        this.maxY = maxY;
    }
}
//# sourceMappingURL=RTreeID.js.map